import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Landing from '@/components/Landing'
import Messaging from '@/components/Admin/adminMessaging'
import AdminLogin from '@/components/Admin/adminLogin'
import GroupData from '@/components/Admin/adminGroupData'
import Avatar from '@/components/Avatar/Avatar'
import Challenge from '@/components/Challenge/Challenge'
import FitnessHistory from '@/components/Fitness/FitnessHistory'
import Market from '@/components/Market'
import createNewAvatarModal from '@/components/Avatar/createNewAvatarModal'
import cameraModal from '@/components/Avatar/cameraModal'
import loaderModal from '@/components/Avatar/loaderModal'
import firebase from 'firebase'
import registerModal from '@/components/Registration/registerModal'
import adminRegisterModal from '@/components/Admin/adminRegister'
import Inbox from '@/components/Inbox/Inbox'
import Account from '@/components/Account'
import AuthGuard from './auth-guard'
import { store } from '../store'

// Needed to make use of the vue-router system
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',        // this is the path in the UR
      name: 'Landing',
      component: Landing  // created component
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/avatar',
      name: 'Avatar',
      component: Avatar,
    },
    {
      path: '/market',
      name: 'Market',
      component: Market,
    },
    {
      path: '/challenge',
      name: 'Challenge',
      component: Challenge,
    },
    {
      path: '/fitnesshistory',
      name: 'FitnessHistory',
      component: FitnessHistory,
    },
    {
      path: '/inbox',
      name: 'Inbox',
      component: Inbox,
    },
    {
      path: '/admin',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/adminMessaging',
      name: 'Messaging',
      component: Messaging,
      beforeEnter: (to, from, next) => {
        if (store.getters.admin) {
          next()
        } else {
          next({ path: '/admin', query: { redirect: to.fullPath } })
          alert("User does not have administrative privileges!")
        }
      }
    },
    {
      path: '/adminGroupData',
      name: 'GroupData',
      component: GroupData,
      beforeEnter: (to, from, next) => {
        if (store.getters.admin) {
          next()
        } else {
          next({ path: '/admin', query: { redirect: to.fullPath } })
          alert("User does not have administrative privileges!")
        }
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js